<template>
  <div id="article" class="data-list-container vs-con-loading__container">
    <div class="vx-breadcrumb mb-6">
      <ul class="flex flex-wrap items-center">
          <li class="inline-flex items-end">
              <router-link to="/after-login">
                  <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" />
              </router-link>
              <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
          </li>
          <li class="inline-flex items-end">
            <span class="breadcrumb-separator mx-2 mb-1" style="color:#626262">Article</span>
          </li>
      </ul>
    </div>

    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between w-row mb-6 reward-header">
        <div class="flex add-and-history">
          <vs-button class="add-reward-btn" type="border" icon-pack="feather" icon="icon-plus" @click="addNew">Add New</vs-button>
        </div>
        <div class="reward-search con-input-search vs-table--search">
          <input type="text" class="input-search vs-table--search-input border-custom" placeholder="Search article">
          <i class="vs-icon notranslate icon-scale material-icons null">search</i>
        </div>
    </div>

    <add-article :popupAddArticle="popupAddArticle"></add-article>
  </div>
</template>

<script>
export default {
  data(){
    return {
      popupAddArticle:{
        isOpen : false
      }
    }
  },
  methods:{
    addNew(){
      this.popupAddArticle.isOpen = true;
    }
  }
}
</script>
